import React, { useState } from "react";
import { CButton, CSpinner } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPin } from "@coreui/icons";
import { createPin } from "../../../api/pinsApi";
import toastStore from "../../../store/ToastStore";

/** Pins a tool result (AI answer or report widget) to the dashboard's "Закреплено" section. */
export default function PinButton({ serverId, toolName, title, payload, size = "sm" }) {
  const [pinning, setPinning] = useState(false);
  const [pinned, setPinned] = useState(false);

  const handlePin = async () => {
    if (!serverId) return;
    setPinning(true);
    try {
      await createPin(serverId, title, toolName, payload);
      setPinned(true);
      toastStore.success("Закреплено на дашборде.");
    } catch (e) {
      toastStore.error(e?.response?.data?.message || e?.message || "Не удалось закрепить.");
    } finally {
      setPinning(false);
    }
  };

  return (
    <CButton
      size={size}
      color="secondary"
      variant="ghost"
      disabled={pinning || pinned || !serverId}
      onClick={handlePin}
      title={pinned ? "Уже на дашборде" : "Закрепить на дашборде"}
    >
      {pinning ? <CSpinner size="sm" /> : <CIcon icon={cilPin} />} {pinned ? "Закреплено" : "Закрепить"}
    </CButton>
  );
}
